import React from "react";
import FormsSummaryCard from "../child/FormsSummaryCard";
import FormsMonthlyActivityChart from "../child/FormsMonthlyActivityChart";
import FormsByTypeChart from "../child/FormsByTypeChart";
import FormsTopCompletedByFormTable from "../child/FormsTopCompletedByFormTable";

const FormsDashboardLayer = () => {
  return (
    <div className='row gy-4 p-24'>
      <FormsSummaryCard />
      <FormsMonthlyActivityChart />
      <FormsByTypeChart />
      <FormsTopCompletedByFormTable />
    </div>
  );
};

export default FormsDashboardLayer;
